// extracted by mini-css-extract-plugin
export default {"clientName":"Map_clientName__JKnmB","mapSection":"Map_mapSection__ebM3v","map":"Map_map__eMCH3"};